import { useLanguage } from "@/contexts/LanguageContext";
import Reveal from "./Reveal";

const ProblemSection = () => {
  const { t } = useLanguage();

  const thoughts = [
    { titleKey: "problem.1.title", descKey: "problem.1.desc", offset: "md:mt-0", tilt: "-0.6deg" },
    { titleKey: "problem.2.title", descKey: "problem.2.desc", offset: "md:mt-10", tilt: "0.8deg" },
    { titleKey: "problem.3.title", descKey: "problem.3.desc", offset: "md:mt-4", tilt: "-0.4deg" },
  ];

  return (
    <section className="py-24 bg-paper">
      <div className="container mx-auto px-6">
        <Reveal className="text-center mb-16 max-w-2xl mx-auto">
          <div className="eyebrow mb-4" style={{ color: "#6C4DFF" }}>{t("eyebrow.problem")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-paper-ink mb-4">{t("problem.title")}</h2>
          <p className="text-lg text-paper-ink/70">{t("problem.sub")}</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-8 md:gap-6 max-w-5xl mx-auto">
          {thoughts.map((point, i) => (
            <Reveal key={i} as="article" delay={i * 110} className={point.offset}>
              <div
                className="relative pl-6 md:pl-7"
                style={{ transform: `rotate(${point.tilt})` }}
              >
                <span
                  aria-hidden
                  className="absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-full"
                  style={{ background: i === 1 ? "#FF7A59" : "#6C4DFF", opacity: 0.55 }}
                />
                <h3 className="font-display text-[26px] md:text-[28px] leading-[1.15] text-paper-ink mb-3">
                  {t(point.titleKey)}
                </h3>
                <p className="text-paper-ink/65 text-[15px] leading-relaxed">{t(point.descKey)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
